module.exports = __webpack_public_path__ + "img/home5.a5a8c40b.png";